import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { colorShade } from '../../utils/style';
import { _UINotificationController } from './NotificationController';

export interface NotificationBodyProps {
    id: number;
    title?: string;
    body?: JSX.Element;
    duration?: number;
}

const animationTimeMs = 400;

export default function NotificationBody({ id, title, body, duration = 3000 }: NotificationBodyProps) {
    const selfRef = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setVisible(false);
            //https://bugzilla.mozilla.org/show_bug.cgi?id=1774814
            setTimeout(() => _UINotificationController.remove(id), animationTimeMs);
        }, duration + animationTimeMs)
        requestAnimationFrame(() => { setVisible(true) });
    }, [id]);


    return (
        <Wrapper ref={selfRef} className={visible ? 'visible' : ''}>{title || body}</Wrapper>
    )
}

const Wrapper = styled.div<any>`
    color: #ffffff;
    background-color: ${props => props.theme.backgroundColor};
    background-color: ${props => colorShade(props.theme.backgroundColor, 0.2)};
    border-radius: ${props => props.theme.borderRadius};
    padding: 10px;
    margin: 10px;

    transition: opacity ${animationTimeMs}ms, transform ${animationTimeMs}ms;
    transform: translateY(calc(-100% - 20px));
    opacity: 0;
    
    &.visible {
        transform: translateY(0);
        opacity: 1;
    }
`